import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core'; 
import { CommonModule, NgClass } from '@angular/common';
import { IconCaretsDownComponent, IconCaretDownComponent, IconLogoutComponent,slideDownUp } from '@sukna/shared';
import { NgScrollbarModule } from 'ngx-scrollbar'; 
import { HasPermissionDirective } from '@sukna/shared';
import { navMenuList, INavSubMenu } from '../shared/constants';
import { AuthService } from '../core/services/api/auth.service';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.html',
    imports: [
        CommonModule,
        NgClass,
        TranslatePipe,
        NgScrollbarModule,
        RouterModule,
        IconCaretsDownComponent,
        HasPermissionDirective,
        IconLogoutComponent
    ],
    animations: [slideDownUp],
})
export class SidebarComponent {
    iconCaretDown = IconCaretDownComponent;

    navMenuList = navMenuList

    active = false;
    store: any;
    activeDropdown: string[] = [];
    parentDropdown: string = '';
    constructor(
        private _authService: AuthService,
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
    ) {
        this.initStore();
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    ngOnInit() {
        this.expandDropdownsForCurrentRoute();
        this.setActiveDropdown();
    }

    private expandDropdownsForCurrentRoute(): void {
        const path = this.router.url.split('?')[0];
        for (const item of this.navMenuList) {
            if (!item.isDropdown || !item.submenu) continue;
            if (!this.submenuContainsPath(item.submenu, path)) continue;
            this.activeDropdown.push(item.label);
            for (const sub of item.submenu) {
                if (sub.isDropdown && this.submenuContainsPath(sub.submenu ?? [], path)) {
                    this.activeDropdown.push(sub.label);
                }
            }
        }
    }

    private submenuContainsPath(items: INavSubMenu[], path: string): boolean {
        return items.some((item) =>
            (!!item.link && (path === item.link || path.startsWith(`${item.link}/`))) ||
            (!!item.submenu && this.submenuContainsPath(item.submenu, path)),
        );
    }

    setActiveDropdown() {
        const selector = document.querySelector('.sidebar ul a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }

    toggleMobileMenu() {
        if (window.innerWidth < 1024) {
            this.storeData.dispatch({ type: 'setSidebar', payload: false });
        }
    }

    toggleAccordion(name: string, parent?: string) {
        if (this.activeDropdown.includes(name)) {
            this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
        } else {
            this.activeDropdown.push(name);
        }
    }

    handleLogout() {
        this._authService.logout()
    }
}
